<template>
  <vx-card :title="$t('reports.mental_health.STRESS_CAUSES.title')" v-if="extractedData && selectedStressor">
    <template slot="actions">
    <vs-dropdown vs-trigger-click class="cursor-pointer">
      <small class="flex cursor-pointer">
        <span>{{ selectedStressor }}</span>
        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1"/>
      </small>
      <vs-dropdown-menu class="w-32">
        <template v-for="stressor in availableStressors">
        <vs-dropdown-item @click="onSelected(stressor)" :key="stressor">{{ stressor }}</vs-dropdown-item>
        </template>
      </vs-dropdown-menu>
    </vs-dropdown>
    </template>

    <vs-row vs-align="center" vs-justify="center">
      <vs-col vs-w="12">
        <vue-apex-charts height="200" type="bar" :options="extractedData.chartOptions" :series="extractedData.series"></vue-apex-charts>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>

export default {
  name: 'mental-health-top-stressor-cause-card',
  props: {
    data: Object
  },
  data () {
    return {
      extractedData: null,
      availableStressors: null,
      selectedStressor: null
    };
  },
  watch: {
    data: {
      immediate: true,
      handler (value) {
        this.update(value);
      }
    }
  },
  methods: {
    onSelected (stressor) {
      this.selectedStressor = stressor;
      this.update(this.data);
    },
    update (value) {
      const root = value.analysis.find(n => n.name === 'ROOT');
      const allTime = root.nested.find(n => n.name === 'ALL_TIME');
      const topStressors = allTime.nested.find(n => n.name === 'MAIN_STRESSORS');

      this.availableStressors = topStressors.buckets.map(b => b.key);
      if (this.availableStressors.length && (!this.selectedStressor || this.availableStressors.indexOf(this.selectedStressor) < 0)) {
        this.selectedStressor = this.availableStressors[0];
      } else if (!this.availableStressors.length) {
        this.selectedStressor = null;
      }
      const content = topStressors.buckets.find(b => b.key === this.selectedStressor);
      let data = [];
      let total = 1;
      if (content) {
        const detailStressors = content.nested.find(n => n.name === 'DETAIL_STRESSORS');
        total = detailStressors.buckets.map(b => b.count).reduce((a, b) => a + b, 0);
        data = detailStressors.buckets.map(b => {
          return {
            x: b.key,
            y: b.count
          };
        });
      }

      this.extractedData = {
        series: [
          {
            name: this.$t('reports.global.members'),
            data
          }
        ],
        chartOptions: {
          chart: {
            type: 'bar',
            toolbar: {
              show: false
            }
          },
          colors: [
            '#72359b',
            '#a22d94',
            '#c92886',
            '#e73073',
            '#fb475d',
            '#ff6545',
            '#ff852b',
            '#ffa600',
            '#fbddbe'
          ],
          plotOptions: {
            bar: {
              endingShape: 'rounded',
              columnWidth: '45%',
              horizontal: true,
              distributed: true
            }
          },
          fill: {
            opacity: .8
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            forceNiceScale: true,
            labels: {
              formatter (value) {
                return Math.round(value) === value ? `${value.toFixed(0)}` : '';
              }
            }
          },
          tooltip: {
            enabled: true,
            x: {
              show: true
            },
            y: {
              formatter (val) {
                return `${val} (${((val / total) * 100).toFixed(1)}%)`;
              },
              title: {
                formatter: (seriesName) => `${seriesName}`
              }
            }
          },
          legend: {
            show: false
          }
        }
      };
    }
  }
};
</script>

<style scoped>

</style>
